import { updateTodoList } from '@erikdakoda/todo/ai-tools/updateTodoList';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(updateTodoList);
